import type { HoverIdleSettingsState } from "../types";
import { defaultSettings } from "./hoverIdleDefaults";
import { cloneSettingsState } from "./hoverIdleStateClone";

export function applyProgressEraseToSettings(
  current: HoverIdleSettingsState,
): HoverIdleSettingsState {
  return {
    ...current,
    readHelpTopicIds: [],
    hasSeenAvailableAmplifierUpgradeGuard: false,
    hasSeenMHovButton: false,
    hasSeenNHovButton: false,
  };
}

export function applyAccountPurgeToSettings(): HoverIdleSettingsState {
  return cloneSettingsState(defaultSettings);
}
